import React from 'react';
import './ProgressBar.css';

const ProgressBar = ({ progress = 0, message = null, title = 'Processing Images' }) => {
  const defaultMessage = () => {
    if (progress < 25) return 'Initializing...';
    if (progress >= 25 && progress < 50) return 'Processing images...';
    if (progress >= 50 && progress < 75) return 'Uploading to S3...';
    if (progress >= 75 && progress < 100) return 'Finalizing...';
    if (progress >= 100) return 'Complete!';
  };

  return (
    <div className="progress-container">
      <div className="progress-card glass-card">
        <div className="progress-content">
          <div className="progress-info">
            <span className="progress-label">{title}</span>
            <span className="progress-percentage">{Math.round(progress)}%</span>
          </div>
          
          <div className="progress-bar-wrapper">
            <div className="progress-bar">
              <div 
                className="progress-fill"
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>
          
          <div className="progress-status">
            <span>{message || defaultMessage()}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;